import * as types from '../constants/changePasswordConstants';
const initialState = {
  loading: false,
  loaded: false,
   user: {
     oldpass:null,
     newpass: null,
     confpass:null,
     status: 'failure',

  },
  message:''
};

export default function(state = initialState, action)  {
  switch (action.type) {
     case types.SUCCESS_DEFAULT:
       return {
         ...state,
       };
     case types.FAILURE_DEFAULT:
       return {
         ...state,
      };
    case types.LOAD_CHANGE_PASSWORD:
      return {
        ...state,
        loaded: true,
        user: action.result,
      };
      case types.LOAD_CHANGE_PASSWORD_FAILURE:
        return {
          ...state,
            message: action.result.message ? action.result.message : '',
            loaded: false,
            loggingIn: false,
            error: action.error ? action.error.data : '',
            //showPopup: false
        };
        case types.LOAD_CHANGE_PASSWORD_SETTING:
          return {
            ...state,
            message:''
          };
          case types.LOAD_CHANGE_PASSWORD_SETTING_SUCCESS:
          return{
            ...state,
            message:"Password reset successfully."

          };
          case types.LOAD_CHANGE_PASSWORD_SETTING_FAILURE:
            return {
              ...state,
                message: action.result.message ? action.result.message : '',
                error: action.error ? action.error.data : '',
                //showPopup: false
            };
          case types.BLANK_MSG:
            return {
              ...state,
              message:''
            };
    default:
      return state;
  }
}
